import {
  submissionDetailQuery,
} from "@/lib/pb/submissions";
import { useSearch } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { useWebContainerManager } from "@/lms/playground/WebContainer";
import { Playground } from "@/lms/playground/Playground";
import { generateRandomString } from "@/lib/utils";
import { useState } from "react";


export default function StandalonePreview() {
  const {elementId, sectionId, enrollmentId} = useSearch({ strict: false });
  useWebContainerManager();

  const [mountPoint, setMountPoint] = useState(generateRandomString()); //
  const { data: submission, isPending } = useQuery(
    submissionDetailQuery(
      elementId,
      sectionId,
      enrollmentId,
      { sectionId: sectionId },
    ),
  );

  if(!enrollmentId) return

  if (isPending)  return (
    <div className="flex w-full mt-6">
      <div className="mx-auto text-2xl">Loading...</div>
    </div>
  );
  //  if (submission) return "found submission";
  if (!submission)
    return (
      <div className="flex flex-col w-full mt-6">
        <div className="mx-auto text-2xl">No submission found</div>
        <div className="mx-auto">Did you save your work?</div>
      </div>
    );
  // const options = {
  //   autorun: true,
  //   autoReload: true,
  //   activeFile: submission.data.files.activeFile,
  //   visibleFiles: submission.data.files.visibleFiles,
  //   initMode: "immediate",
  // };

  return (
    <div className="grid h-100dvh  w-full">
      
      <Playground
        fullScreen={true}
        showEditor={false}
        elementId={elementId}
        sectionId={sectionId}
        baseFiles={submission.data.files}
        mountPoint={mountPoint}
        showOpenInCodeSandbox={false}
        height={"full"}
      />
    </div>
  );
}
